/* tslint:disable */
/* eslint-disable */
/**
 * Organization & Workspace Gateway
 * Methods to manage all organizations and workspaces
 *
 * The version of the OpenAPI document: 22
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    PortalAdminInviteResponseEntry,
    PortalAdminInviteResponseEntryFromJSON,
    PortalAdminInviteResponseEntryFromJSONTyped,
    PortalAdminInviteResponseEntryToJSON,
} from './PortalAdminInviteResponseEntry';

/**
 * 
 * @export
 * @interface PortalAdminInviteResponse
 */
export interface PortalAdminInviteResponse {
    /**
     * 
     * @type {Array<PortalAdminInviteResponseEntry>}
     * @memberof PortalAdminInviteResponse
     */
    results?: Array<PortalAdminInviteResponseEntry>;
}

export function PortalAdminInviteResponseFromJSON(json: any): PortalAdminInviteResponse {
    return PortalAdminInviteResponseFromJSONTyped(json, false);
}

export function PortalAdminInviteResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalAdminInviteResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(PortalAdminInviteResponseEntryFromJSON)),
    };
}

export function PortalAdminInviteResponseToJSON(value?: PortalAdminInviteResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(PortalAdminInviteResponseEntryToJSON)),
    };
}

